import Environment from '../../../Environment';
import { RiskRepositoryCode } from './RiskRepositoryCode';

interface SupportingDocumentLinkProps {
  year: number;
  riskRepositoryCode: RiskRepositoryCode;
  statementTypeCode: string;
}

export default function SupportingDocumentLink({
  year,
  riskRepositoryCode,
  statementTypeCode // linkType
}: SupportingDocumentLinkProps) {
  let document;
  let label;
  let docYear;

  switch (riskRepositoryCode) {
    case RiskRepositoryCode.CREDIT:
      label = 'Credit';
      document = 'Profile Risk Assessments/B1/Credit Risk Assessment - Annual';
      break;
    case RiskRepositoryCode.LEGAL:
      label = 'Legal';
      document = 'Profile Risk Assessments/B2/Legal Risk Assessment';
      break;
    case RiskRepositoryCode.LIQUIDITY:
      label = 'Liquidity';
      document = 'Profile Risk Assessments/B3/Liquidity Risk Assessment';
      break;
    case RiskRepositoryCode.MARKET:
      label = 'Market';
      document = 'Profile Risk Assessments/B4/Market Risk Assessment';
      break;
    case RiskRepositoryCode.OPERATIONAL:
      label = 'Operational';
      document = 'Profile Risk Assessments/B5/Operational Risk Assessment';
      break;
    case RiskRepositoryCode.PRICING_AND_UNDERWRITING:
      label = 'Pricing & Underwriting';
      document = 'Profile Risk Assessments/B6/Pricing UW Risk Assessment';
      break;
    case RiskRepositoryCode.REPUTATIONAL:
      label = 'Reputational';
      document = 'Profile Risk Assessments/B7/Reputational Risk Assessment';
      break;
    case RiskRepositoryCode.RESERVING:
      label = 'Reserving';
      if (statementTypeCode === 'P') {
        document = 'Profile Risk Assessments/B8/PC/Reserves PC Risk Assessment';
      } else if (statementTypeCode === 'L') {
        document = 'Profile Risk Assessments/B8/Life/Reserves Life Risk Assessment';
      } else if (statementTypeCode === 'X') {
        document = 'Profile Risk Assessments/B8/Health/Reserves Health Risk Assessment';
      }
      break;
    case RiskRepositoryCode.STRATEGIC:
      label = 'Strategic';
      document = 'Profile Risk Assessments/B9/Strategic Risk Assessment';
      break;
  }

  docYear = year <= 2024 ? 2024 : year;

  return (
    <a
      href={`${Environment.ISITE_URL()}/secure/fah/${docYear}/${document}.pdf`}
      target="_blank"
      rel="noreferrer">
      {`${label} Risk Assessment`}
    </a>
  );
}
